export default __webpack_public_path__ + "static/media/Text-field.8e4ac56b.png";